import type { FaireProductEntity } from "../../entity_types/product";

export const p_8cdvr6o3: FaireProductEntity = {
  token: "p_8cdvr6o3",
  type: "product",
  name: "Magnolia Bath Bomb",
  brandToken: "b_cb27ceb3",
  brandName: "Old Whaling Company",
  imageUrl:
    "https://cdn.faire.com/fastly/35fb2594e96777eb29323d331e9918ed0eb57cd11efa50e858e5583a7bec5723.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b99a35bbb8a7bba890bab84dbda2d5469c67b9f1306cfd88d134f7f7fc47563f.jpeg",
    "https://cdn.faire.com/fastly/78519152920a291756e1de1d09a4ae6d98527eaeda683de421d5c24735b3716a.jpeg",
    "https://cdn.faire.com/fastly/6f10e449225199bace79ccc797354ad1e2e6978c209b4fc60dfc55deea4aaaa5.jpeg",
    "https://cdn.faire.com/fastly/e0de9b9fc06ef641afb2d1df245a06a7986a968d1d153e4dfb3bf95ef28435d4.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c690358e89eaf075146702c9f887aa5dc0fb596ae52c652e00b24b6ff8cfbb82/1534447770.jpg",
    "https://cdn.faire.com/fastly/8ea2efdd12586cc982bccaa0aa47f07d258518ffc1b3a4b31f92c6e482805e69.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e5e00c095e0609c07c65c8b996bd8bd25c0308757545100fe59900633c3fc940/1536338083.jpg",
  ],
  priceDollars: 4,
  description:
    "This fragrant blend of magnolia blossoms and sweet peonies embodies the beauty of spring in the South. A bold floral fragrance, this popular scent will transport you to idyllic days along the southern coast with every use. \n\nTop: Magnolia Blossoms, Sun Kissed Peony, Green Leaves\nBase: Sweet Balsam, Rosewood, Water Lily\n\nHandmade in historic Charleston, SC, with baking soda, citric acid, epsom salts, olive, and soybean oil, each Old Whaling Co. 8oz bath bomb will leave your skin feeling moisturized and lightly scented. Our handcrafted bath bomb's soothing fizz and sea-inspired fragrance are perfect for a relaxing soak, rejuvenating the senses and cleansing the skin.\n\nOur bath bombs come individually boxed, and are wrapped in cellophane bags inside the box. \n\nOur bath bombs always make for great gifts! ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:45.892Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
